import {gql} from '@apollo/client'
export const queryApplicensesList=gql`
query Query($isPermanent: Boolean!, $page: Int!, $count: Int!, $name: String, $startDate: Date, $endDate: Date) {
  getApplicensesList(isPermanent: $isPermanent, page: $page, count: $count, name: $name, startDate: $startDate, endDate: $endDate) {
    data {
      company
      developerEmail
      appName
      status
      solutions
      platform
      licenseTrialRange
      isPermanent
      expireTime
      permanentTime
      deviceList
    }
    total
  }
}
`
